<template>
	<div>
		<sBox title="Grade de categorias">
			<div slot="tools">
				<aBtn
					action="private-save-categories"
					@click="$refs.modal.open()"
					text="Categoria"
					icon="plus"
					size="sm"
					type="success"
				/>
			</div>
			<div slot="body">
				<br />
				<div class="row">
					<div class="pull-right col-sm-4">
						<div class="input-group">
							<span class="input-group-addon">
								<i class="fa fa-search"></i>
							</span>
							<input
								type="text"
								@input="filter($event.target.value)"
								placeholder="Pesquisar"
								class="form-control"
							/>
						</div>
					</div>
				</div>
				<br />
				<sTable
					ref="tab"
					actionRead="private-read-categories"
					actionDelete="private-delete-categories"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';

	import pad from 'js/pad';

	export default {
		name: 'AppCadastroCategorias',
		components: { sTable, sBox, modal, aBtn },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'titulo', label: 'Categorias' },
					{ data: 'reducao', label: 'Redução de Tempo' },
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
				],
			};
		},
		methods: {
			filter(data) {
				if (data != '') {
					this.$refs.tab.setFilter(`
							cod like '%${data}%' or
							titulo like '%${data}%' or
							reducao like '%${data}%'
					`);
				} else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento de Categorias', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/categorias/index.vue